// RouteError — the route-level errorElement. React Router 7 renders it for any
// uncaught render crash, loader error, OR lazy `import()` chunk-load failure in
// the routes it covers. Mounted on the authed-pages wrapper so a page failure
// renders INSIDE the shell chrome (the Navbar stays, the user can navigate
// away); also on RootLayout as the chrome-less fallback for pre-auth / not-found.
// The top-level class ErrorBoundary (App.tsx) remains the last resort for
// provider / router-shell crashes that escape the router entirely.

import { useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/Button.js';
import { Link } from '../ui/Link.js';
import { ErrorState } from './ErrorState.js';

export function RouteError() {
  const { t } = useTranslation('common');
  const error = useRouteError();
  // No frontend log shipper yet — surface to devtools (matches ErrorBoundary).
  // eslint-disable-next-line no-console
  console.error('Route error', error);
  return (
    <ErrorState
      title={t('error.title')}
      message={t('error.body')}
      actions={
        <>
          <Link to="/">{t('error.goHome')}</Link>
          <Button variant="primary" onClick={() => window.location.reload()}>
            {t('actions.reload')}
          </Button>
        </>
      }
    />
  );
}
